import Page from "@/layout/page.vue";
import Home from "@/views/Home.vue";

// 統一使用單一響應式元件
const view = (name) => () => import(`@/views/${name}.vue`);

const strict = { pathToRegexpOptions: { strict: true } };

const routeConfigs = [
  {
    path: "aboutUs",
    fileName: "AboutUs",
    title: "chatXbuy 代買幫 | 關於我們 - 台灣專業代購團隊",
    description:
      "chatXbuy代買幫：台灣在地團隊，提供合法合規1688代購服務。我們的願景是讓海外購物享有安全保障，使命是提供專業一條龍服務，解決金流物流問題。",
    ogTitle: "chatXbuy 代買幫 | 您的1688代購夥伴",
    ogDescription:
      "合法、專業、保障的台灣代購團隊。多年豐富經驗，細心掌握每個流程，為您的代購體驗保駕護航。",
  },
  {
    path: "freight",
    fileName: "Fee",
    title: "chatXbuy 代買幫 | 費用說明與計算方式 - 透明報價",
    description:
      "chatXbuy代買幫費用透明：商品費×匯率+訂單手續費+國際運費。空運4-7天、海快7-12天。提供材積計算工具，普貨特貨分類說明。",
    ogTitle: "chatXbuy 代買幫 | 1688代購費用計算",
    ogDescription:
      "透明收費結構：空運海快選擇，材積重量計算，讓您清楚每筆費用。",
  },
  {
    path: "faq",
    fileName: "Faq",
    title: "chatXbuy 代買幫 | 常見問題 Q&A - 代購疑問解答",
    description:
      "chatXbuy代買幫常見問題解答：服務範圍、代付集運、協助找貨議價、客服時間週一至週五09:30-18:30。解答您所有1688代購疑問。",
    ogTitle: "chatXbuy 代買幫 | 1688代購常見問題",
    ogDescription:
      "專業解答代購相關問題：平台服務、費用計算、運送方式、售後服務。客服時間週一至週五09:30-18:30。",
  },
  {
    path: "prohibit",
    fileName: "Prohibit",
    title: "chatXbuy 代買幫 | 禁運商品清單 - 了解運送限制",
    description:
      "chatXbuy代買幫禁運商品說明：電池類、液體、粉末、易燃物、仿冒品等禁止運送。了解台灣海關規定，避免訂購無法運送的商品。",
    ogTitle: "chatXbuy 代買幫 | 禁運商品須知",
    ogDescription: "了解1688代購禁運商品清單，避免訂購違禁品造成損失。",
  },
  {
    path: "service",
    fileName: "Service",
    title: "chatXbuy 代買幫 | 服務介紹 - 7步驟完成1688代購",
    description:
      "chatXbuy代買幫服務流程：從選商品到收貨只需7步驟。支援訂單合併、普貨特貨運送、商業報關。會員制度享匯率優惠，最快8小時內報價。",
    ogTitle: "chatXbuy 代買幫 | 1688代購服務流程",
    ogDescription:
      "7步驟輕鬆完成代購：選商品→聊天機器人下單→報價→付款→寄送→取貨。專業售後服務，協助與廠商溝通。",
  },
  {
    path: "blogList",
    fileName: "BlogList",
    title: "chatXbuy 代買幫 | 代購知識部落格 - 批貨教學與經驗分享",
    description:
      "chatXbuy代買幫部落格：1688批貨教學、代付風險分析、團購賣家攻略、居家商品選購指南。提供最新代購知識與實戰經驗分享。",
    ogTitle: "chatXbuy 代買幫 | 1688批貨知識庫",
    ogDescription:
      "專業代購文章：法律風險分析、選品技巧、訂單管理工具推薦。幫助您成為批貨達人！",
  },
  {
    path: "blogTopic",
    fileName: "BlogTopic",
    title: "chatXbuy 代買幫 | 代購知識部落格 - 瀏覽更多文章",
    description:
      "chatXbuy代買幫部落格：1688批貨教學、代付風險分析、團購賣家攻略、居家商品選購指南。提供最新代購知識與實戰經驗分享。",
    ogTitle: "chatXbuy 代買幫 | 1688批貨知識庫 - 瀏覽更多文章",
    ogDescription:
      "專業代購文章：法律風險分析、選品技巧、訂單管理工具推薦。幫助您成為批貨達人！",
  },
  {
    path: "termsService",
    fileName: "TermsService",
    title: "chatXbuy 代買幫 | 服務條款 - 使用者規範與權益",
    description:
      "chatXbuy代買幫服務條款：詳細說明使用者權益、服務範圍、付款方式、退換貨政策及免責聲明。使用本服務前請詳閱相關條款。",
    ogTitle: "chatXbuy 代買幫 | 服務條款",
    ogDescription: "了解chatXbuy代買幫服務條款，保障您的消費權益。",
  },
  {
    path: "privacyPolicy",
    fileName: "PrivacyPolicy",
    title: "chatXbuy 代買幫 | 隱私權政策 - 個資保護說明",
    description:
      "chatXbuy代買幫隱私權政策：說明個人資料蒐集、使用、保護方式。我們重視您的隱私，確保資料安全。",
    ogTitle: "chatXbuy 代買幫 | 隱私權政策",
    ogDescription: "了解chatXbuy代買幫如何保護您的個人資料與隱私。",
  },
];

// 使用單一 component 取代 named views
const childRoutes = routeConfigs.map(
  ({ path, fileName, title, description, ogTitle, ogDescription }) => ({
    path,
    name: path.split("/")[0],
    component: view(fileName),
    meta: {
      title,
      description,
      ogTitle,
      ogDescription,
    },
    ...strict,
  }),
);

// blogTopic 可爬分頁：/page/blogTopic/2、/3...（第 1 頁維持無數字的 /page/blogTopic）
// 沿用 blogTopic 的 meta，App.vue 即可依 route.path 自動產出每頁的 canonical/og:url
const blogTopicRoute = childRoutes.find((r) => r.name === "blogTopic");
childRoutes.push({
  path: "blogTopic/:page(\\d+)",
  name: "blogTopicPage",
  component: view("BlogTopic"),
  meta: blogTopicRoute.meta,
  ...strict,
});

export const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "chatXbuy 代買幫 | 1688阿里巴巴批發代購平台 - 專業一條龍服務",
      description:
        "代買幫是專門從1688阿里巴巴上批貨的平台，提供一次性收費、報價後再決定是否要付款、機器人聊天下單以及主動告知貨運進度，只要交給代買幫，讓您輕鬆選購，安心批貨！",
      ogTitle: "chatXbuy 代買幫 | 專業1688批發代購平台",
      ogDescription:
        "聊天機器人一鍵下單，透明報價，全程追蹤。台灣最專業的1688代購服務，讓批貨變簡單！",
    },
  },
  {
    path: "/page",
    component: Page,
    children: [...childRoutes],
  },
  // 404：預渲染成 dist/404.html 供 Firebase Hosting 當 custom 404 用
  {
    path: "/404",
    name: "notFound",
    component: () => import("@/views/NotFound.vue"),
    meta: {
      title: "chatXbuy 代買幫 | 找不到頁面",
      description: "您造訪的頁面不存在或已移除，請回首頁或瀏覽部落格文章。",
      ogTitle: "chatXbuy 代買幫 | 找不到頁面",
      ogDescription: "您造訪的頁面不存在或已移除。",
      noindex: true,
    },
  },
  // SPA 內部導航到不存在路徑時顯示同一頁（保留原網址，不做 redirect）
  {
    path: "/:pathMatch(.*)*",
    name: "notFoundCatchAll",
    component: () => import("@/views/NotFound.vue"),
    meta: {
      title: "chatXbuy 代買幫 | 找不到頁面",
      description: "您造訪的頁面不存在或已移除，請回首頁或瀏覽部落格文章。",
      ogTitle: "chatXbuy 代買幫 | 找不到頁面",
      ogDescription: "您造訪的頁面不存在或已移除。",
      noindex: true,
    },
  },
];
